export class AppConfig {
  sumoLogicURL: string | undefined;
  amplitudeApiKey?: string;
  signUpUrl: string | undefined;
  shopHost: string | undefined;
  featureHeroAllowedEnterprises: string[] | undefined;
  googleAnalyticsTrackingId?: string;
  googleReCaptchaSiteKey: string | undefined;
  masterCardResetPasswordUrl: string | undefined;
}

export class AppWindow extends Window {
  portalConfig!: AppConfig;
}

export interface LocalStorage {
  getItem: (key: string) => string | null;

  setItem(key: string, value: string): void;
}

export const appWindow: AppWindow = window as unknown as AppWindow;
